import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import { localizeDate } from '../../../utils/vuex';
import ApiService from '../../../services/apiService';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import packetChartMixin from '@/components/core/virtualDevice/packetChartMixin';
import io from 'socket.io-client';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
var oneDayInMilliseconds = 86400 * 1000;
var defaultDuration = 7 * oneDayInMilliseconds;
var statisticsFetchModeFull = 'full';
export default {
  name: 'CoreVirtualDeviceSmartGroupsDashboard',
  mixins: [multiSearchMixin, packetChartMixin],
  props: {
    accounts: {
      type: Array,
      required: true
    },
    bridgeTypesProp: {
      type: Array,
      required: true
    },
    viewModel: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      // setInterval ID for updating statistics every X seconds
      updateInterval: null,
      tabFocusListener: null,
      // only fetch the total device count every half hour, not for each new packet via websocket
      lastTotalCountFetch: 0,
      lastGraphsDataFetch: 0,
      tabIsInFocus: true,
      priorIntervalDataFetchTs: 0,
      cachedHourlyPriorData: [],
      cachedDailyPriorData: [],
      // to reduce unnecessary fetching for "active devices per day", only refresh if a NEW device comes in
      // keep all device-ids in a map for fastest access, if the websocket pushes a new packet check if it is a unknown device
      // if it already is in this map, then there is no need to perform a new fetch for `active devices per day`
      activeDeviceIds: {},
      reloadDeviceStatistics: true,
      timeRange: {
        // from: 7 days before
        from: new Date(Date.now() - defaultDuration) / 1000,
        to: Date.now() / 1000,
        endIsNow: true
      },
      searchItems: [],
      searchOperator: 'AND',
      viewPackets: {
        today: 0,
        yesterday: 0,
        last24Hours: 0
      },
      packetHistory: [],
      debouncedPacketHistory: [],
      viewPacketSocket: null,
      chartsHeight: 200,
      hourlyMetricsData: {
        common: {
          labels: []
        },
        individual: [{
          data: []
        }, {
          data: []
        }]
      },
      dailyMetricsData: {
        common: {
          labels: []
        },
        individual: [{
          data: []
        }, {
          data: []
        }]
      },
      // disable device-metrics (for now)
      // https://digimondo.atlassian.net/browse/RD-7047
      // activeDevicesMetricsData: {
      //   common: {
      //     labels: [],
      //   },
      //   individual: [
      //     {
      //       data: [],
      //     },
      //     {
      //       data: [],
      //     },
      //   ],
      // },
      // totalDevicesMetricsData: {
      //   common: {
      //     labels: [],
      //   },
      //   individual: [
      //     {
      //       data: [],
      //     },
      //     {
      //       data: [],
      //     },
      //   ],
      // },
      isFetchingExecute: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled', 'language', 'permissions'])), mapGetters({
    tenantId: 'authentication/tenantId'
  })), {}, {
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatusItems: function operationalStatusItems() {
      var _this = this;

      return Object.keys(this.operationalStatus).map(function (status) {
        return {
          text: _this.operationalStatus[status],
          value: status
        };
      });
    },
    filteredSearchTypes: function filteredSearchTypes() {
      return this.searchTypes.filter(function (item) {
        return item.param === 'operationalStatus' || item.param === 'bridge.type';
      });
    },
    defaultSearchType: function defaultSearchType() {
      return this.filteredSearchTypes.find(function (item) {
        return item.param === 'operationalStatus';
      });
    },
    datePickerMinDate: function datePickerMinDate() {
      return new Date(Date.now() - 86400 * 31 * 1000).toISOString();
    },
    hourlyMetricOptions: function hourlyMetricOptions() {
      return cloneDeep(this.packetMetricsOptions);
    },
    hourlyMetricsComp: function hourlyMetricsComp() {
      return this.createPacketMetricsDataComp('hourlyMetricsData');
    },
    dailyMetricsComp: function dailyMetricsComp() {
      return this.createPacketMetricsDataComp('dailyMetricsData');
    },
    activeDevicesMetricsComp: function activeDevicesMetricsComp() {
      return this.createPacketMetricsDataComp('activeDevicesMetricsData', this.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.activeDevices'));
    },
    totalDevicesMetricsComp: function totalDevicesMetricsComp() {
      return this.createPacketMetricsDataComp('totalDevicesMetricsData', this.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.totalDevices'));
    }
  }),
  watch: {
    '$route.params.id': {
      handler: function handler(newV, oldV) {
        if (newV !== oldV) {
          this.resetCachingParams(); // tear down websocket

          this.teardownWebSocket();
          this.setupWebSocket(this.$route.params.id);
        }
      }
    },
    bridgeTypesProp: function bridgeTypesProp() {
      (this.searchTypes.find(function (item) {
        return item.param === 'bridge.type';
      }) || {}).items = this.bridgeTypesProp;
    },
    viewModel: function viewModel() {
      this.resetCachingParams(); // reset any search, make sure the `fetchViewDetails` publishes the new base virtual-device-count

      this.searchItems = [];
      this.fetchViewDetails(statisticsFetchModeFull);
    }
  },
  mounted: function mounted() {
    (this.searchTypes.find(function (item) {
      return item.param === 'operationalStatus';
    }) || {}).items = this.operationalStatusItems;
    this.setupWebSocket(this.$route.params.id);
    this.detectTabFocusLeave(); // NOTE: disable auto-update (for now), reduce Influx load and only update graphs manually
    // auto-update, practically only as fallback if websockets do not come through
    // do not perform too frequently, to avoid annoyance
    // this.updateInterval = setInterval(() => {
    //   this.fetchViewDetailsDebounced();
    // }, 90000);
  },
  destroyed: function destroyed() {
    clearInterval(this.updateInterval);
    this.teardownWebSocket();

    if (this.tabFocusListener) {
      document.removeEventListener('visibilitychange', this.tabFocusListener);
    }
  },
  methods: {
    get: get,
    localizeDate: localizeDate,
    findAccountById: function findAccountById(id) {
      return this.accounts.find(function (account) {
        return account.id === id;
      });
    },
    detectTabFocusLeave: function detectTabFocusLeave() {
      this.tabFocusListener = document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          this.tabIsInFocus = false;
        } else {
          this.tabIsInFocus = true;
        }
      });
    },
    resetCachingParams: function resetCachingParams() {
      // reset all caching
      this.reloadDeviceStatistics = true;
      this.lastTotalCountFetch = 0;
      this.priorIntervalDataFetchTs = 0;
      this.activeDeviceIds = {};
    },
    searchUpdated: function searchUpdated() {
      this.forceFetchViewDetails();
    },
    setTimeRange: function setTimeRange(data) {
      // reset fetch date, for new picked time-ranges always fetch the total device count
      this.lastTotalCountFetch = 0;
      this.timeRange = {
        from: data.from,
        to: data.to,
        endIsNow: Math.abs(data.to * 1000 - Date.now()) < 60000
      }; // no debounce for this, keep the UI reactive to user-inputs

      this.fetchViewDetails(statisticsFetchModeFull);
    },
    // only fetch new data once every 10 seconds at most, even if a flood of live-packets come in
    fetchViewDetailsDebounced: debounce(function () {
      this.fetchViewDetails();
    }, 9000, // fetch immediately, and then "discard" all following requests for next 10 seconds
    {
      leading: true
    }),
    forceFetchViewDetails: function forceFetchViewDetails() {
      this.resetCachingParams(); // no debounce for this, keep the UI reactive to user-inputs

      this.fetchViewDetails(statisticsFetchModeFull);
    },
    fetchViewDetails: function fetchViewDetails(fetchMode) {
      var _this2 = this;

      this.isFetchingExecute = true;
      var operationalStatus = (this.searchItems.find(function (item) {
        return item.param === 'operationalStatus';
      }) || {}).search;
      operationalStatus = (operationalStatus || {}).value || operationalStatus;
      var bridgeType = (this.searchItems.find(function (item) {
        return item.param === 'bridge.type';
      }) || {}).search;
      bridgeType = (bridgeType || {}).value || bridgeType;
      var viewId = this.$route.params.id;
      return this._fetchViewExecute(viewId, operationalStatus, bridgeType).then(function (data) {
        _this2.viewPackets = _objectSpread(_objectSpread({}, _this2.viewPackets), {}, {
          devices: data.total,
          errors: data.alert,
          warnings: data.warn
        });

        _this2.$emit('related-templates-count', data.relatedTemplatesCount);

        if (operationalStatus === undefined && bridgeType === undefined) {
          _this2.$emit('virtual-device-count', data.total);
        } // get "general statistics" for statistics-card


        return ApiService.virtualDeviceViewGetPacketStatistics(_this2, viewId, operationalStatus, bridgeType);
      }).then(function (data) {
        _this2.viewPackets = _objectSpread(_objectSpread({}, _this2.viewPackets), {}, {
          last24Hours: data.last24Hours.count,
          prior24Hours: data.prior24Hours.count
        });
        _this2.isFetchingExecute = false; // skip updating the graphs with historical data, unless triggered manually

        if (fetchMode === statisticsFetchModeFull) {
          return _this2._fetchPacketCountHistory(_this2.$route.params.id, operationalStatus, bridgeType);
        }

        return null;
      }).catch(function (e) {
        console.error('Could not fetch view', e);
      }).finally(function () {
        _this2.isFetchingExecute = false; // after initial rendering of graphs, disable animation

        setTimeout(function () {
          _this2.enableChartAnimations = false;
        }, 1000);
      });
    },
    // only call from within fetchViewDetails
    _fetchViewExecute: function _fetchViewExecute(viewId, operationalStatus, bridgeType) {
      return ApiService.virtualDeviceViewsExecute(this, viewId, operationalStatus, bridgeType).then(function (response) {
        return response;
      }).catch(function (error) {
        console.error(error);
      });
    },
    // only call from within fetchViewDetails
    _fetchPacketCountHistory: function _fetchPacketCountHistory(viewId, operationalStatus, bridgeType) {
      var _this3 = this;

      if (this.isLoadingPacketMetrics || !this.tabIsInFocus) {
        return;
      }

      this.isLoadingPacketMetrics = true;
      this.lastGraphsDataFetch = Date.now(); // show the threshold-value for packets, in either the hourly or daily chart, depending on the selected interval
      // first clean em up, and then add the threshold as "static line"

      this.hourlyMetricsData.individual = this.hourlyMetricsData.individual.slice(0, 2);
      this.dailyMetricsData.individual = this.dailyMetricsData.individual.slice(0, 2);

      if (this.viewModel.meta.monitoring.isActive && this.viewModel.meta.monitoring.threshold) {
        if (parseInt(this.viewModel.meta.monitoring.interval) === 60) {
          this.hourlyMetricsData.individual = [].concat(_toConsumableArray(this.hourlyMetricsData.individual), [{
            data: Array.from(Array(24).keys()).map(function () {
              return _this3.viewModel.meta.monitoring.threshold;
            })
          }]);
        }

        if (parseInt(this.viewModel.meta.monitoring.interval) === 1440) {
          this.dailyMetricsData.individual = [].concat(_toConsumableArray(this.dailyMetricsData.individual), [{
            data: Array.from(Array(7).keys()).map(function () {
              return _this3.viewModel.meta.monitoring.threshold;
            })
          }]);
        }
      }

      var lclTimeFrom = (Date.now() - defaultDuration) / 1000;

      if (this.timeRange.from) {
        // want to have a minimum-range of 7 days for the daily packet-statistics
        lclTimeFrom = Math.min(this.timeRange.from, lclTimeFrom);
      }

      var lclTimeTo = this.timeRange.endIsNow ? Date.now() : this.timeRange.to * 1000;
      var rangeStart = new Date(lclTimeFrom * 1000);
      var rangeTo = new Date(lclTimeTo);
      var interval = rangeTo - rangeStart;
      var priorRangeStart = new Date(rangeStart - interval); // show skeleton-loaders for each of these, and make them available as soon as they are finished,
      // do not wait until `isLoadingPacketMetrics` is reset, because the last request may take some seconds longer

      this.hourlyMetricsComp.common.labels = [];
      this.dailyMetricsComp.common.labels = [];
      var shouldFetchPriorData = this.priorIntervalDataFetchTs <= Date.now() - 600 * 1000; // =======
      // HOURLY PACKETS
      // =======
      // fetch the last 24h of the selected range, as well as the "parallel" history exactly 1 interval prior
      // NOTE: since the prior interval is fixed in the past, there is no need to refresh it with every request
      // it MAY change, if the smartgroup-filter-criteria change, but at least during this page-load keep it cached for 10min

      return Promise.allSettled([ApiService.virtualDeviceViewGetPacketStatistics(this, viewId, operationalStatus, bridgeType, new Date(lclTimeTo - oneDayInMilliseconds), rangeTo, '1h'), shouldFetchPriorData ? ApiService.virtualDeviceViewGetPacketStatistics(this, viewId, operationalStatus, bridgeType, new Date(lclTimeTo - 2 * oneDayInMilliseconds), new Date(lclTimeTo - oneDayInMilliseconds), '1h') : Promise.resolve(this.cachedHourlyPriorData)]).then(function (results) {
        var dataCurrent = results[0].status === 'fulfilled' ? results[0].value : [];
        var dataPrior = results[1].status === 'fulfilled' ? results[1].value : [];

        if (shouldFetchPriorData) {
          _this3.cachedHourlyPriorData = dataPrior;
          _this3.priorIntervalDataFetchTs = Date.now();
        }

        _this3.preparePacketMetricsData(dataCurrent, dataPrior, 'hourlyMetricOptions', 'hourlyMetricsData', true); // =======
        // DAILY PACKETS
        // =======


        return Promise.allSettled([ApiService.virtualDeviceViewGetPacketStatistics(_this3, viewId, operationalStatus, bridgeType, rangeStart, rangeTo, '1d'), shouldFetchPriorData ? ApiService.virtualDeviceViewGetPacketStatistics(_this3, viewId, operationalStatus, bridgeType, priorRangeStart, rangeStart, '1d') : Promise.resolve(_this3.cachedDailyPriorData)]);
      }).then(function (results) {
        var dataCurrent = results[0].status === 'fulfilled' ? results[0].value : [];
        var dataPrior = results[1].status === 'fulfilled' ? results[1].value : [];

        if (shouldFetchPriorData) {
          _this3.cachedDailyPriorData = dataPrior;
        }

        _this3.preparePacketMetricsData(dataCurrent, dataPrior, 'packetMetricsOptions', 'dailyMetricsData', true); // disable device-metrics (for now)
        // https://digimondo.atlassian.net/browse/RD-7047
        // // =======
        // // ACTIVE/TOTAL DEVICE STATISTICS
        // // =======
        // const reloadActiveCounts = this.lastTotalCountFetch <= Date.now() - 1800 * 1000;
        // if (this.reloadDeviceStatistics) {
        //   this.activeDevicesMetricsComp.common.labels = [];
        //   if (reloadActiveCounts) {
        //     this.totalDevicesMetricsComp.common.labels = [];
        //   }
        // }
        // return this.reloadDeviceStatistics
        //   ? ApiService.virtualDeviceViewGetDeviceStatistics(
        //       this,
        //       viewId,
        //       operationalStatus,
        //       bridgeType,
        //       rangeStart,
        //       rangeTo,
        //       '1d',
        //       // do not refresh the total devices. that is a heavy request that has no need to run every X seconds
        //       reloadActiveCounts ? ['activeCounts'] : undefined
        //     )
        //   : Promise.resolve(null);


        return null;
      }).then(function () {
        // this.reloadDeviceStatistics = false;
        // if (data === null) {
        //   return null;
        // }
        // const activeCounts = data.activeCounts.map((cnt) => {
        //   return { time: cnt.time, count: cnt.devices };
        // });
        // this.preparePacketMetricsData(activeCounts, [], 'packetMetricsOptions', 'activeDevicesMetricsData', true);
        // // contains only 1 data-set, so remove label for second one
        // if (this.activeDevicesMetricsData.individual.length > 1) {
        //   this.activeDevicesMetricsData.individual.pop();
        // }
        // if (data.totalCunts) {
        //   this.lastTotalCountFetch = Date.now();
        //   this.preparePacketMetricsData(data.totalCunts, [], 'packetMetricsOptions', 'totalDevicesMetricsData', true);
        //   // contains only 1 data-set, so remove label for second one
        //   if (this.totalDevicesMetricsData.individual.length > 1) {
        //     this.totalDevicesMetricsData.individual.pop();
        //   }
        // }
        return null;
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this3.isLoadingPacketMetrics = false;
      });
    },
    teardownWebSocket: function teardownWebSocket() {
      if (this.viewPacketSocket) {
        this.viewPacketSocket.close();
      }
    },
    setupWebSocket: function setupWebSocket(viewId) {
      if (viewId) {
        var viewPacketSocket = io("".concat(process.env.VUE_APP_API_HOST, "/virtualdevice/view/").concat(viewId, "/packet"), {
          query: "token=".concat(localStorage.getItem('token')),
          allowEIO3: true
        });
        var instance = this;
        viewPacketSocket.on('update', function (data) {
          var _instance$debouncedPa;

          var fromUnknownDevice = false; // keep new packets in separate array, until they are "debounced"

          (_instance$debouncedPa = instance.debouncedPacketHistory).push.apply(_instance$debouncedPa, _toConsumableArray(data.virtualDevices.map(function (item) {
            // only perform a refresh of device-statistics, if this device was not seen before
            if (!instance.activeDeviceIds[item.externalId]) {
              fromUnknownDevice = true;
              instance.activeDeviceIds[item.externalId] = true;
            }

            return _objectSpread(_objectSpread({}, item), {}, {
              timestamp: item.time
            });
          })));

          instance.reloadDeviceStatistics = instance.reloadDeviceStatistics || fromUnknownDevice; // make a throttled call, do not refresh everything for every packet

          instance.throttledPushPacket();
        });
        this.viewPacketSocket = viewPacketSocket;
      }
    },
    throttledPushPacket: throttle(function () {
      this.packetHistory = [].concat(_toConsumableArray(this.debouncedPacketHistory), _toConsumableArray(this.packetHistory));
      this.debouncedPacketHistory = [];
      this.fetchViewDetailsDebounced(); // 10 second throttle-window
    }, 10000)
  }
};